/**
 * True when NEX reported HTTP 406 for this invoice (duplicate submission or other 406 rule).
 * Matches feed `reasonFlags.dupe` / `getInvoiceFeed` logic for the NEX path.
 */
export function invoiceHasNexDuplicate406Error(invoice: {
    reconciliationIssues?: { nexSubmissionError?: { status?: number } | null } | null;
    nexSubmission?: { lastStatus?: string; lastError?: { status?: number } | null } | null;
}): boolean {
    if (invoice.reconciliationIssues?.nexSubmissionError?.status === 406) return true;
    if (invoice.nexSubmission?.lastStatus === 'failed' && invoice.nexSubmission?.lastError?.status === 406) {
        return true;
    }
    return false;
}

/** True when PartBay detected a prior submitted invoice for the same vendor + invoice number + type. */
export function invoiceHasPartbayDuplicate(invoice: {
    invoiceType?: string | null;
    reconciliationIssues?: { partbayDuplicate?: { priorInvoiceUuid?: string } | null } | null;
}): boolean {
    if (invoice.invoiceType === 'return_slip') return false;
    return !!invoice.reconciliationIssues?.partbayDuplicate?.priorInvoiceUuid;
}

/** DUPE badge: NEX 406 or PartBay prior-submission duplicate. PartBay dupes no longer lock Submit. */
export function invoiceHasDuplicateFlag(invoice: {
    invoiceType?: string | null;
    reconciliationIssues?: {
        nexSubmissionError?: { status?: number } | null;
        partbayDuplicate?: { priorInvoiceUuid?: string } | null;
    } | null;
    nexSubmission?: { lastStatus?: string; lastError?: { status?: number } | null } | null;
}): boolean {
    return invoiceHasNexDuplicate406Error(invoice) || invoiceHasPartbayDuplicate(invoice);
}
